module.exports = __webpack_public_path__ + "img/icon_shalou.f0110e0b.svg";